import { Routes as AppRoutes, BrowserRouter, Route } from "react-router-dom";
import { Home } from "../../Pages/Home";
import { LoginScreen } from "../LoginScreen";
import { ProtectedRoute } from "./ProtectedRoutes";
import { PublicRoute } from "./PublicRoutes";
import Callback from "../Callback";

export function Routes() {
    return (
        <BrowserRouter>
            <AppRoutes>
                {/* PUBLIC ROUTES */}
                <Route element={<PublicRoute />}>
                    <Route path="/" element={<Callback />} />
                    <Route path="/login" element={<LoginScreen />} />
                </Route>

                {/* PRIVATE ROUTES */}
                <Route element={<ProtectedRoute />}>
                    <Route path="/*" element={<Home />} />
                    <Route path="/registry/item/:id/:mainTab?/:subTab?" element={<Home />} />
                    <Route path="/configurations/:mainTab?/:subTab?" element={<Home />} />
                </Route>

                {/* NO MATCH ROUTES */}
                {/* <Route path="*" element={<NoMatch />} /> */}
            </AppRoutes>
        </BrowserRouter>
    );
}